"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperationParamId = exports.getOperationParamEditor = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importDefault(require("react"));
const data_1 = require("@grafana/data");
const ui_1 = require("@grafana/ui");
const QueryEditor_1 = require("../../QueryEditor");
function getOperationParamEditor(paramDef) {
    if (paramDef.editor) {
        return paramDef.editor;
    }
    if (paramDef.options) {
        return SelectInputParamEditor;
    }
    switch (paramDef.type) {
        case 'boolean':
            return BoolInputParamEditor;
        case 'number':
        case 'string':
        default:
            return SimpleInputParamEditor;
    }
}
exports.getOperationParamEditor = getOperationParamEditor;
function SimpleInputParamEditor(props) {
    var _a;
    return (react_1.default.createElement(ui_1.AutoSizeInput, { id: getOperationParamId(props.operationId, props.index), defaultValue: (_a = props.value) === null || _a === void 0 ? void 0 : _a.toString(), minWidth: props.paramDef.minWidth, placeholder: props.paramDef.placeholder, title: props.paramDef.description, maxWidth: (props.paramDef.minWidth || 20) * 3, onCommitChange: (evt) => {
            props.onChange(props.index, evt.currentTarget.value);
            if (props.paramDef.runQueryOnEnter && evt.type === 'keydown') {
                props.onRunQuery();
            }
        } }));
}
function BoolInputParamEditor(props) {
    return (react_1.default.createElement(ui_1.Checkbox, { id: getOperationParamId(props.operationId, props.index), value: Boolean(props.value), onChange: (evt) => props.onChange(props.index, evt.currentTarget.checked) }));
}
function SelectInputParamEditor({ paramDef, value, index, operationId, onChange, }) {
    var _a, _b;
    const styles = (0, ui_1.useStyles2)(getStyles);
    let selectOptions = paramDef.options;
    if (!((_a = selectOptions[0]) === null || _a === void 0 ? void 0 : _a.label)) {
        selectOptions = paramDef.options.map((option) => ({
            label: option.toString(),
            value: option,
        }));
    }
    let valueOption = (_b = selectOptions.find((x) => x.value === value)) !== null && _b !== void 0 ? _b : (0, data_1.toOption)(value);
    // If we have optional options param and don't have value, we want to render button with which we add optional options.
    // This makes it easier to understand what needs to be selected and what is optional.
    if (!value && paramDef.optional) {
        return (react_1.default.createElement("div", { className: styles.optionalParam },
            react_1.default.createElement(ui_1.Button, { size: "sm", variant: "secondary", title: `Add ${paramDef.name}`, icon: "plus", onClick: () => onChange(index, selectOptions[0].value) }, paramDef.name)));
    }
    return (react_1.default.createElement(QueryEditor_1.EditorStack, { gap: 0.5, direction: "row", alignItems: "center" },
        react_1.default.createElement(ui_1.Select, { id: getOperationParamId(operationId, index), value: valueOption, options: selectOptions, placeholder: paramDef.placeholder, allowCustomValue: true, onChange: (value) => onChange(index, value.value), width: paramDef.minWidth || 'auto' }),
        paramDef.optional && (react_1.default.createElement(ui_1.Button, { "data-testid": `operations.${index}.remove-param`, size: "sm", fill: "text", icon: "times", variant: "secondary", title: `Remove ${paramDef.name}`, onClick: () => onChange(index, '') }))));
}
const getStyles = (theme) => {
    return {
        optionalParam: (0, css_1.css)({
            marginTop: theme.spacing(1),
        }),
    };
};
function getOperationParamId(operationId, paramIndex) {
    return `operations.${operationId}.param.${paramIndex}`;
}
exports.getOperationParamId = getOperationParamId;
//# sourceMappingURL=OperationParamEditor.js.map